export default __webpack_public_path__ + "static/BURGERCARD-974ee6ceb56ce40d7491fb681fb46af7.mp4";